<div class="col-md-12">
    <div class="card card-user full-dashboard-bgcover">
        <div class="card-body">
            <form [formGroup]="profileForm" (ngSubmit)="saveProfile()" #ProfileForm="ngForm" novalidate>
                <div class="row">
                    <div class="col-12">
                        <div class="profile-div">
                            <img id="userProfilePreview" src="../../../../../assets/img/default_img.jpg"
                                title="User profile" class="img-fluid profile-image" alt="image">
                            <label for="ProfilePicture" id="add-employee-icon">
                                <i class="fa fa-camera" (click)="file.click()"></i>
                            </label>
                        </div>
                        <input style="display: none;" type="file" class="custom-file-input" accept=".png, .jpg, .jpeg"
                            id="uploadUserImage" (change)="onFileChanged($event)" #file>
                        <span id="userProfileName"></span>
                    </div>
                    <div class="col-lg-12 col-md-12 col-12">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group mb-4">
                                    <label>First Name <span class="form-control-danger">*</span></label>
                                    <input type="text" class="form-control" required autocomplete="off"
                                        formControlName="FirstName" placeholder="Enter First Name"
                                        [ngClass]="{'form-control-danger': ProfileForm.submitted && profileFormControl['FirstName'].errors?.['required']}"
                                        maxlength="20" oninput="this.value = this.value.replace(/^\s+/g, '')">
                                    <span class="text-danger"
                                        *ngIf="ProfileForm.submitted && profileFormControl['FirstName'].errors?.['required']">
                                        {{errorMessage.FirstNameIsRequired}}
                                    </span>
                                    <span class="text-danger"
                                        *ngIf="profileFormControl['FirstName'].errors?.['maxlength']">
                                        Max length is 20 characters.
                                    </span>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group mb-4">
                                    <label>Last Name <span class="form-control-danger">*</span></label>
                                    <input type="text" class="form-control" required autocomplete="off"
                                        formControlName="LastName" placeholder="Enter Last Name"
                                        [ngClass]="{'form-control-danger': ProfileForm.submitted && profileFormControl['LastName'].errors?.['required']}"
                                        maxlength="20" oninput="this.value = this.value.replace(/^\s+/g, '')">
                                    <span class="text-danger"
                                        *ngIf="ProfileForm.submitted && profileFormControl['LastName'].errors?.['required']">
                                        {{errorMessage.LastNameIsRequired}}
                                    </span>
                                    <span class="text-danger"
                                        *ngIf="profileFormControl['LastName'].errors?.['maxlength']">
                                        Max length is 20 characters.
                                    </span>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group mb-4">
                                    <label>User Email <span class="form-control-danger">*</span></label>
                                    <input type="text" class="form-control" required autocomplete="off"
                                        formControlName="EmailId">
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group mb-4">
                                    <label>Mobile Number <span class="form-control-danger">*</span></label>
                                    <input type="text" class="form-control" required autocomplete="off"
                                        formControlName="PhoneNo" placeholder="Enter Mobile Number"
                                        [ngClass]="{'form-control-danger': ProfileForm.submitted && profileFormControl['PhoneNo'].errors?.['required']}"
                                        maxlength="10" oninput="this.value = this.value.replace(/^\s+/g, '')">
                                    <span class="text-danger"
                                        *ngIf="ProfileForm.submitted && profileFormControl['PhoneNo'].errors?.['required']">
                                        {{errorMessage.MobileNumberIsRequired}}
                                    </span>
                                    <span class="text-danger"
                                        *ngIf="ProfileForm.submitted && profileFormControl['PhoneNo'].errors?.['pattern']">
                                        {{errorMessage.MobileaNumberIsInvalid}}
                                    </span>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group mb-4">
                                    <label>User Role <span class="form-control-danger">*</span></label>
                                    <input type="text" class="form-control" required autocomplete="off"
                                        formControlName="UserRole">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="d-flex justify-content-center flex-sm-row flex-column mt-3 mb-3">
                            <button type="submit" class="btn common-button me-3"
                                id="btn-save">{{commonConstant.UPDATE}}</button>
                            <button type="button" class="btn btn-border common-button"
                                (click)="onCancel()">{{commonConstant.CANCEL}}</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>